export const mockAPIPath = {
    TRANSACTION_LIST: "./data/paymentReportsTransaction.json"
};

export const serverAPIPath = {
    TRANSACTION_LIST: "/oms/sales/list"
};